import React, { FC } from 'react';
import { ReactComponent as Export1CIcon } from 'app/assets/images/redesign/export-1c.svg';
import { RequestStatus } from 'entities/Request/components/RequestStatus';
import { getRequestIdForView, getRequestStatus } from 'entities/Request/Request.helper';
import { IRequest } from 'entities/Request/Request.models';

interface IComponentProps {
  request: IRequest;
  isSeller?: boolean;
}

export const RequestTitle: FC<IComponentProps> = ({ isSeller, request }) => {
  const { isProcessingRequest } = getRequestStatus(request.status);

  return (
    <div className="mb-11 request-title">
      <div className="request-title__container">
        <span className="text-h1">{`Заказ ${getRequestIdForView(request.id, request.createdAt)}`}</span>

        <RequestStatus status={request.status} />
      </div>

      {isSeller && isProcessingRequest && (
        <div className="request-title__export-indicator">
          <Export1CIcon className="icon-export-1c-dark-grey" />

          <span className="text-tag color-dark-grey">Передан в учетную систему</span>
        </div>
      )}
    </div>
  );
};
